import { render } from "./Conversations.vue?vue&type=template&id=0dc2dbfd&scoped=true&ts=true"
import script from "./Conversations.vue?vue&type=script&lang=ts"
export * from "./Conversations.vue?vue&type=script&lang=ts"

import "./Conversations.vue?vue&type=style&index=0&id=0dc2dbfd&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc2dbfd"]])

export default __exports__